import { useQuery } from 'react-query';
import { MeetingAPI } from 'api/meeting/api';

export const useIsAiFillsBetaEnabled = () => {
  const { data, isLoading } = useQuery(['ai-fills-feature-flag'], () =>
    MeetingAPI.getMeetingsBetaEnabled(),
  );

  return { data: data?.enabled, isLoading };
};
